import moment from 'moment';
import { useEffect } from 'react';

export function useScheduledAction(when, callback) {
    useEffect(() => {
        const now = moment(),
            then = moment(when);

        if (!then.isValid()) return;

        const diff = now.diff(then);
        if (diff < 0) {
            const timeout = setTimeout(callback, -1 * diff);
            return () => clearTimeout(timeout);
        } else {
            callback();
        }
    }, [when, callback]);
}
